import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class LifetimeSubmitButtonService {
    public readonly requestIsPending$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public readonly requestStarted$: Subject<void> = new Subject();
}
